import { RouteObject } from 'react-router-dom';
import IndexRoute from '@/portal/routes/_index/Route.tsx';
import ProvidersIndexRoute, {
  loader as providersIndexLoader,
} from '@/portal/routes/providers/index/Route.tsx';
import ProvideNewRoute, {
  action as providerNewAction,
} from '@/portal/routes/providers/new/Route.tsx';
import ProviderShowRoute, {
  loader as providerShowLoader,
} from '@/portal/routes/providers/$providerId/Route.tsx';
import ProviderEditRoute, {
  loader as providerEditLoader,
  action as providerEditAction,
} from '@/portal/routes/providers/$providerId/edit/Route.tsx';
import { action as providerDeleteAction } from '@/portal/routes/providers/$providerId/delete/Route.tsx';
import ProvidersRoot from '@/portal/routes/providers/Root.tsx';
import SettingsRoute from '@/portal/routes/settings/Route.tsx';

export const authenticatedRoutes: RouteObject[] = [
  {
    index: true,
    element: <IndexRoute />,
  },
  {
    path: 'providers',
    element: <ProvidersRoot />,
    children: [
      {
        index: true,
        element: <ProvidersIndexRoute />,
        loader: providersIndexLoader,
      },
      {
        path: 'new',
        element: <ProvideNewRoute />,
        action: providerNewAction,
      },
      {
        path: ':providerId',
        element: <ProviderShowRoute />,
        loader: providerShowLoader,
      },
      {
        path: ':providerId/edit',
        element: <ProviderEditRoute />,
        loader: providerEditLoader,
        action: providerEditAction,
      },
      {
        path: ':providerId/delete',
        action: providerDeleteAction,
      },
    ],
  },
  {
    path: 'settings',
    element: <SettingsRoute />,
  },
];
